import { Box, Grid, Icon, ListItem, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import CompareInvoiceCard from "../invoice/CompareInvoiceCard";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreIFrame from "../../core/dataDisplay/CoreIFrame";
import { useDispatch, useSelector } from "react-redux";
import {
  commonPDFDocumentDownload,
  downloadInvoiceFile,
} from "../../store/actions/billActions";

import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";

import { api_request, downloadExcel } from "../../store/actions/commonAction";
import CoreButton from "../../core/inputs/CoreButton";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import CorePdfViewer from "../../core/dataDisplay/CorePdfViewer";
import { useLocation } from "react-router";
import { API_METHOD_GET } from "../../config/constants";
import {
  GET_DOC_ERROR,
  GET_DOC_LOADING,
  GET_DOC_SUCCESS,
} from "../../store/types/billTypes";

export default function DeedProcessorSingle() {
  const dispatch = useDispatch();
  const location = useLocation();

  const deedData = useSelector((state) => state?.deed?.deedData);
  const invoiceFileUrl = useSelector((state) => state?.bill?.invoiceFileUrl);
  const docId = useSelector((state) => state.bill?.docId);

  const [document, setDocument] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [imageStyle, setImageStyle] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [highlightedField, setHighlightedField] = useState(null);

  const tool = location.pathname.split("/")[1];

  useEffect(() => {
    if (deedData && tool !== "maruti-doc-management") {
      setDocument(deedData?.document);
    }
  }, [deedData]);

  useEffect(() => {
    if (tool === "maruti-doc-management") {
      getdocDetails();
    }
  }, []);

  const getdocDetails = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/maruti/doc/" + docId + "/details",
        {},
        {},
        GET_DOC_LOADING,
        GET_DOC_SUCCESS,
        GET_DOC_ERROR,
        true,
        true,
      ),
    );
  };

  useEffect(() => {
    if (invoiceFileUrl) {
      var img = new Image();
      img.onload = function () {
        var height = img.height;
        var width = img.width;
        // code here to use the dimensions
        if (height > width) {
          setImageStyle({ height: "100%", maxHeight: "100%" });
        } else {
          setImageStyle({ width: "100%" });
        }
      };

      img.src = invoiceFileUrl;
    }
  }, [invoiceFileUrl]);

  useEffect(() => {
    if (document) {
      if (document?.url?.includes(".pdf")) {
        dispatch(downloadInvoiceFile(document.id, "pdf"));
        setFileType("pdf");
      } else {
        dispatch(downloadInvoiceFile(document.id, "image"));
        setFileType("image");
      }
    }
  }, [document]);

  const propertyChainColumns = [
    { label: "Reg. Date", name: "Date of Registration" },
    { label: "Buyer", name: "Buyer Name" },
    { label: "Seller", name: "Seller Name" },
    { label: "Mouza", name: "Mouza" },
  ];

  const ownerChainColumns = [
    { label: "Reg. No", name: "property_registration_number" },
    { label: "Buyer", name: "buyer_name" },
    { label: "Seller", name: "seller_name" },
    { label: "Deed Nature", name: "nature_of_deed" },
    { label: "Reg. Date", name: "date_of_registration" },
  ];

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={7}>
          <CompareInvoiceCard>
            <Tooltip title="Download File">
              <CoreIconButton
                onClick={() => {
                  if (document?.url.includes(".pdf")) {
                    dispatch(downloadInvoiceFile(document?.id, "pdf", false));
                    setFileType("pdf");
                  } else {
                    dispatch(downloadInvoiceFile(document?.id, "jpg", false));
                    setFileType("image");
                  }
                }}
                style={{
                  backgroundColor: "white",
                  position: "absolute",
                  top: 80,
                  opacity: 0.8,
                }}
              >
                <Icon>download</Icon>
              </CoreIconButton>
            </Tooltip>
            {fileType === "image" ? (
              imageStyle && (
                <div
                  id="image-viewer"
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={imageStyle}
                    src={invoiceFileUrl}
                    alt="Loading ..."
                  />
                </div>
              )
            ) : fileType === "pdf" ? (
              <CorePdfViewer
                fileUrl={invoiceFileUrl}
                highlight={highlightedField}
                setHighlight={setHighlightedField}
              />
            ) : null}
          </CompareInvoiceCard>
        </Grid>
        <Grid item xs={12} sm={5} style={{ height: "100%", width: "100%" }}>
          <CompareInvoiceCard>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <CoreButton
                variant="text"
                onClick={() => {
                  setPageNum(pageNum === 1 ? 2 : 1);
                }}
              >
                {pageNum === 1 ? "Next" : "Back"}
              </CoreButton>
            </div>
            <Box
              style={{
                minHeight: "100%",
                maxHeight: "100%",
                overflowY: "auto",
                padding: 12,
              }}
            >
              {pageNum === 1 ? (
                deedData &&
                deedData.parse_data &&
                deedData.parse_data.data && (
                  <>
                    {deedData.parse_data.data.map((row, index) => (
                      <ListItem
                        key={index + "-" + row.name}
                        // style={{ padding: 2 }}
                        button
                        onClick={() =>
                          setHighlightedField({
                            page: row.page,
                            box: row.box_2d,
                          })
                        }
                      >
                        <div>
                          <strong>{row.name}</strong>
                          <CoreTypographyBody1></CoreTypographyBody1>
                          <CoreTypographyBody1>{row.value}</CoreTypographyBody1>
                        </div>
                      </ListItem>
                    ))}
                    {deedData.parse_data["Area"] && (
                      <Grid xs={6} item>
                        <CoreTypographyBody1>
                          <strong>Area</strong>
                        </CoreTypographyBody1>
                        <CoreTypographyBody1>
                          {deedData.parse_data["Area"].join(", ")}
                        </CoreTypographyBody1>
                      </Grid>
                    )}
                  </>
                )
              ) : (
                <Box
                  style={{
                    height: "100%",
                    minHeight: "400px",
                    width: "100%",
                  }}
                >
                  {deedData?.property_chain && (
                    <Box style={{ marginBottom: 24 }}>
                      <CoreTypographyBody1 style={{ marginBottom: 8 }}>
                        <strong>Property Chain</strong>
                      </CoreTypographyBody1>
                      <CoreDataTable
                        columns={propertyChainColumns}
                        dataRows={deedData.property_chain}
                        selectable={false}
                        showToolbar={false}
                      />
                    </Box>
                  )}
                  {deedData?.owner_chain && (
                    <Box>
                      <CoreTypographyBody1 style={{ marginBottom: 8 }}>
                        <strong>Owner Chain</strong>
                      </CoreTypographyBody1>
                      <CoreDataTable
                        columns={ownerChainColumns}
                        dataRows={deedData.owner_chain}
                        selectable={false}
                        showToolbar={false}
                      />
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </CompareInvoiceCard>
        </Grid>
      </Grid>
    </Box>
  );
}
